import { render, staticRenderFns } from "./big-icon-panel.vue?vue&type=template&id=d1fb11be&scoped=true"
import script from "./big-icon-panel.vue?vue&type=script&lang=ts"
export * from "./big-icon-panel.vue?vue&type=script&lang=ts"
import style0 from "./big-icon-panel.vue?vue&type=style&index=0&id=d1fb11be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1fb11be",
  null
  
)

export default component.exports